import { App } from '../App'
import { lang } from '../assets/lang'
import CONST_SOCKET from '../const/socket'
import { showWarning } from '../functions/utils'

export const warnIfConnectionLimitCrosses = (connection) => {
  const readNodeConnections = () => {
    const inputKeyNamesWithValue = new Map()

    if (Array.isArray(connection.output.connections)) {
      connection.output.connections.forEach(singleConnection => {
        if (inputKeyNamesWithValue.has(singleConnection.input.key)) {
          inputKeyNamesWithValue.set(
            singleConnection.input.key, 
            inputKeyNamesWithValue.get(singleConnection.input.key) + 1
          )
        } else {
          inputKeyNamesWithValue.set(singleConnection.input.key, 1)
        }
      })
    }

    return inputKeyNamesWithValue
  }

  /**
   * Shows warning if socket connections cross the specified limit
   * 
   * connectionData = [{
   *    inputKey: 'Name of the input key that is connected to an output of a node, 
   *    i.e. textOutput, buttonInput etc',
   *    limit: 'The number of connections a node can take'
   * }]
   * 
   * @param { Object } connectionData An array of objects representing node connection info
   */      
  const checkConnectionLimitForMultipleNodes = (connectionData) => { // eslint-disable-line
    if (Array.isArray(connectionData)) {
      const connectedSockets = readNodeConnections()

      connectionData.forEach(data => {
        if (connectedSockets.has(data.inputKey)) {
          if (connectedSockets.get(data.inputKey) > data.limit) {
            const message = `${lang.plugin_connection_limit} ${data.limit} ${connection.input.node.lingualName} ${lang.plugin_components}`
            showWarning(message)
            App.editor.removeConnection(connection)
          }
        }
      })
    }        
  }

  const checkConnectionLimitForSingleNode = (limit) => {
    const totalConnections = connection.output.connections.length

    if (totalConnections > limit) {
      const message = `${lang.plugin_connection_limit} ${limit} ${connection.input.node.lingualName} ${lang.plugin_components}`
      showWarning(message)
      App.editor.removeConnection(connection)
    }
  }

  const socketKey = connection.output.key

  if (socketKey) {
    switch (socketKey) {
      case CONST_SOCKET.TEXT_OUTPUT_BUTTON:
        return checkConnectionLimitForSingleNode(3)

      case CONST_SOCKET.TEXT_OUTPUT_QUICKREPLY:
        return checkConnectionLimitForSingleNode(11)

      case CONST_SOCKET.AUDIO_OUTPUT_QUICKREPLY:
        return checkConnectionLimitForSingleNode(11)

      case CONST_SOCKET.CAROUSEL_OUTPUT_QUICKREPLY:
        return checkConnectionLimitForSingleNode(11)

      case CONST_SOCKET.CAROUSEL_OUTPUT_ITEMS:
        return checkConnectionLimitForSingleNode(10)

      case CONST_SOCKET.FACEBOOK_MEDIA_OUTPUT_BUTTON:
        return checkConnectionLimitForSingleNode(3)

      case CONST_SOCKET.FACEBOOK_MEDIA_OUTPUT_QUICKREPLY:
        return checkConnectionLimitForSingleNode(11)

      case CONST_SOCKET.FILE_OUTPUT_QUICKREPLY:
        return checkConnectionLimitForSingleNode(11)

      case CONST_SOCKET.GENERIC_TEMPLATE_OUTPUT_BUTTON:
        return checkConnectionLimitForSingleNode(3)

      case CONST_SOCKET.GENERIC_TEMPLATE_OUTPUT_QUICKREPLY:
        return checkConnectionLimitForSingleNode(11)

      case CONST_SOCKET.IMAGE_OUTPUT_QUICKREPLY:
        return checkConnectionLimitForSingleNode(11)

      case CONST_SOCKET.VIDEO_OUTPUT_QUICKREPLY:
        return checkConnectionLimitForSingleNode(11)

      case CONST_SOCKET.ECOMMERCE_OUTPUT_QUICKREPLY:
        return checkConnectionLimitForSingleNode(11)

      case CONST_SOCKET.CAROUSEL_ITEM_OUTPUT:
        return checkConnectionLimitForSingleNode(3)


      // case CONST_SOCKET.FACEBOOK_MEDIA_OUTPUT_BUTTON:
      //   return checkConnectionLimitForMultipleNodes([
      //     { inputKey: CONST_SOCKET.BUTTON_INPUT, limit: 3 }, 
      //     { inputKey: CONST_SOCKET.QUICK_REPLY_INPUT, limit: 11 }, 
      //   ])
      // case CONST_SOCKET.CAROUSEL_OUTPUT_ITEMS:
      //   return checkConnectionLimitForSingleNode(10)
      // case CONST_SOCKET.GENERIC_TEMPLATE_OUTPUT_BUTTON:
      //   return checkConnectionLimitForSingleNode(3)
      default:
        return
    }
  }
}